// extracted by mini-css-extract-plugin
module.exports = {"font-family-light":"TreatwellSansWeb-Light","blocks":"style-module--blocks--30789a","title":"style-module--title--ed0370","columns":"style-module--columns--9bc242"};